import { useField, useFormikContext } from "formik";
import { useEffect } from "react";

// A variant of Formik's useField that removes the field from Formik on unmount. This is needed for dynamic form fields.
// If a dynamic field is activated and then hidden again by the user, it would still get posted in form submissions if we
// did not remove it here.
export const useFieldCustom: typeof useField = nameOrOptions => {
  const [field, ...fieldProperties] = useField(nameOrOptions);
  const formik = useFormikContext();

  useEffect(
    () => () => {
      formik.setFieldValue(field.name, undefined, false);
    },
    // Don't add deps alarmed by ESLint, will cause this effect to loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return [field, ...fieldProperties];
};
